export enum HelpCenterEventNames {
    Close = "close",
}

export enum HelpCenterCardId {
    GuidesAndTutorials = "guides-and-tutorials",
    PopularFaqs = "popular-faqs",
    RaiseACase = "raise-a-case",
    LatestUpdates = "latest-updates",
}

export interface HelpCenterCard {
    id: HelpCenterCardId;
    title: string;
    description: string;
    actionLabel: string;
    badge?: number;
}
